import { API } from '../../lib/api';
import Feedback from '../../components/Feedback/Feedback';
import { useState } from 'react';
import Module from './Module';
import { useNavigate } from 'react-router-dom';
import { BarChart, Storm } from '@mui/icons-material';
import { TextField } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

const Content = () => {
    const { user } = useAuth();
    const [searchQuery, setSearchQuery] = useState('');
    const [feedback, setFeedback] = useState({ open: false, message: '', type: '' });
    const navigate = useNavigate();
    const openForecasting = () => {
        if (!['admin', 'manager'].includes(localStorage.role)) {
            setFeedback({ open: true, message: 'You do not have permission to access this module.', type: 'error' });
            return;
        }
        navigate('/modules/revenue-lines-flat');
    };
    const addForecasting = async () => {
        const response = await API.Dashboard.AddModule(localStorage.id, 'revenue-lines-flat');
        setFeedback({ open: true, message: response.status === 200 ? response.data.message : 'Failed to add module to dashboard.', type: response.status === 200 ? 'success' : 'error' });
    };
    const modules = [
        { title: 'Forecasting', description: 'Forecasting Tool', onClick: openForecasting, onAdd: addForecasting, moduleName: 'revenue-lines-flat', icon: <Storm color="primary" sx={{ fontSize: 50 }} /> },
        { title: 'Weekly Quotes Report (Graph & Grid)', description: 'Open Weekly Quotes Report', onClick: () => navigate('/modules/weekly-quotes-report'), moduleName: 'weekly-quotes-report', icon: <BarChart color="error" sx={{ fontSize: 50 }} /> },
    ];
    return <>
        <Feedback props={feedback} setFeedback={setFeedback} />
        <div style={{ marginBottom: '1rem', textAlign: 'center' }}>
            <TextField label="Search Modules" value={searchQuery} onChange={event => setSearchQuery(event.target.value)} sx={{ width: 300, maxWidth: '100%' }} />
        </div>
        <div className="row hive-reporting-modules" style={{ justifyContent: 'center' }}>
            {modules.filter(module => (module.moduleName !== 'revenue-lines-flat' || ['admin', 'manager'].includes(user?.role)) && module.title.toLowerCase().includes(searchQuery.toLowerCase())).map(module => <Module key={module.moduleName} {...module} />)}
        </div>
    </>;
};
export default Content;
